import circleEmpty from "../../image/circle-empty.svg";
import circleMarked from "../../image/circle-marked.svg";
import { PersonCodeProps } from "../../../../types/props";
import "./PersonCode.scss";
import { useState } from "react";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import { useWidth } from "../../../../hooks/useWidth";
import { getAuthToken, getTextWidth } from "../../../../utils/utils";
import { API_BASE } from "../../../../config/api";

const PersonCode = ({ ...props }: PersonCodeProps) => {
  const { id, ticket, invalid, handleClear } = props;
  const [isMarked, setIsMarked] = useState<boolean>(ticket.used);
  const [isShowDetails, setIsShowDetails] = useState<boolean>(false);
  const url = `${API_BASE}`;
  const isMobile = useIsMobile();
  const width = useWidth();

  const token = getAuthToken();

  const handleClick = async () => {
    try {
      const response = await fetch(`${url}/tickets/check/`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
        credentials: "include",
        body: JSON.stringify({
          ticket_number: ticket.ticket_number,
          event_id: id,
        }),
      });

      if (!response.ok) {
        throw new Error("Ошибка при обновлении");
      }

      setIsMarked((prev) => {
        const newState = !prev;
        if (newState) {
          handleClear();
        }
        return newState;
      });
      handleShowDetails();
    } catch (e) {
      alert(e);
    }
  };

  const handleShowDetails = () => {
    if (width < 1024) setIsShowDetails((prev) => !prev);
    else return;
  };

  const isColumnLayout = () => {
    const font: string = "Montserrat";
    const size: string = "16px";
    const weight: string = "bold";
    const nameWidth = getTextWidth(ticket.user_name, weight, size, font);
    const emailWidth = getTextWidth(ticket.user_email, weight, size, font);

    return (
      (!isMobile && width < 1170) ||
      width < 375 ||
      nameWidth + emailWidth > 198.5
    );
  };

  return (
    <div className="person-code">
      <div className="person-code__container">
        <div
          className={
            `person-code__info ` +
            (invalid ? "person-code__info--invalid " : "") +
            (isMarked ? "person-code__info--marked " : "")
          }
          onClick={!invalid ? handleShowDetails : undefined}
        >
          <span
            className={`person-code__text person-code__text__number ${
              isMarked ? "person-code__text--marked" : ""
            }`}
          >
            {ticket.ticket_number}
          </span>
          {isColumnLayout() ? (
            <div className="person-code__name-and-email">
              <span
                className={`person-code__text ${
                  isMarked ? "person-code__text--marked" : ""
                }`}
              >
                {ticket.user_name}
              </span>
              <span
                className={`person-code__text ${
                  isMarked ? "person-code__text--marked" : ""
                }`}
              >
                {ticket.user_email}
              </span>
            </div>
          ) : (
            <>
              <span
                className={`person-code__text ${
                  isMarked ? "person-code__text--marked" : ""
                }`}
              >
                {ticket.user_name}
              </span>
              <span
                className={`person-code__text ${
                  isMarked ? "person-code__text--marked" : ""
                }`}
              >
                {ticket.user_email}
              </span>
            </>
          )}
        </div>
      </div>
      {(isShowDetails || width > 1024) && !invalid && (
        <button
          className={`person-code__check-button 
                                ${
                                  invalid
                                    ? "person-code__check-button--disabled"
                                    : ""
                                }
                                ${
                                  isMarked
                                    ? "person-code__check-button--marked"
                                    : ""
                                }`}
          disabled={isMarked}
          onClick={handleClick}
        >
          <span
            className={`person-code__btn-text
                                ${
                                  isMarked
                                    ? "person-code__btn-text--marked"
                                    : ""
                                }`}
          >
            {isMarked ? "Отмечено" : "Отметить"}
          </span>
          <img src={isMarked ? circleMarked : circleEmpty} alt="Circle Mark" />
        </button>
      )}
    </div>
  );
};

export default PersonCode;
